


































































































import { Watch } from 'vue-property-decorator';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';

import CrudStepsNavBar from '@/reusable/Mantenedor/CrudStepsNavBar.vue';
import { PasosCrud } from '@/reusable/Mantenedor/mantenedorUtils';
import ContenidoModal from '@/reusable/Modal/ContenidoModal.vue';

// import AsociarMensajesForm from '@/pantallas/CopilotoVirtual/Ruta/AsociarMensajesForm.vue';
import AsociarMensajesFormDetalle from '@/pantallas/CopilotoVirtual/Ruta/AsociarMensajesFormDetalle.vue';
import CabeceraModalCrear from '@/reusable/Modal/CabeceraModalCrear.vue';

import NavegacionModalCrud from '@/reusable/Mantenedor/NavegacionModalCrud.vue';
import CrudStepperHeader from '@/reusable/Mantenedor/CrudStepperHeader.vue';
import CrudStepperItems from '@/reusable/Mantenedor/CrudStepperItems.vue';
import CrudStepperContent from '@/reusable/Mantenedor/CrudStepperContent.vue';

import AsociarFlotaEtiquetaVehiculoIndividual from '@/reusable/AsociarFlotaEtiquetaVehiculoIndividual/AsociarFlotaEtiquetaVehiculoIndividual.vue';

import { Vue, Component, Prop } from 'vue-property-decorator';
import TextField from '@/reusable/Form/TextField.vue';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { Snotify } from '@/snotify/Snotify';
import { LoadingService } from '@/services/loadingService';
import { Funcionalidades } from '@/config/funcionalidades';
import { fetchReportesSerie } from '@/pantallas/Conecta/EditarVehiculos/fetchReporteSerie';
import config from '@/config/index';
import { Validator } from 'vee-validate';
import ValidaRut from '@/config/validaRut';
import { string } from 'yup';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    CrudStepsNavBar,
    ContenidoModal,
    CabeceraModalCrear,
    TextField,
    FormFieldsContainer,
    // AsociarMensajesForm,
    AsociarMensajesFormDetalle,
    NavegacionModalCrud,
    CrudStepperContent,
    CrudStepperItems,
    CrudStepperHeader,
    AsociarFlotaEtiquetaVehiculoIndividual,
  },
})
export default class VerEditarModal extends Vue {
  @Prop({ default: null }) Motivo: any;
  @Prop({ default: true }) show: boolean;
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  correcto: boolean = true;
  axiosCopiloto: AxiosVue = new AxiosVue(ServicioProxy.Copiloto);

  idRuta: number = null;
  demo: any = {};

  lstEventoMensajes: any[] = [];

  pasoActivoIndex = 1;
  readonly pasos: PasosCrud = {
    requerimiento: {
      accion: 'Editar Vehiculos',
      visible: true,
      step: 1,
      title: 'Detalle Motivo de Baja ',
      icon: 'ballot',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
    },
  };
  @Prop({ default: false }) modoVer: boolean;
  @Prop({ default: false }) nuncaEdit: boolean;
  cambio: boolean = false;
  vr: ValidaRut = new ValidaRut();
  anio: any = '';
  dictionaryFormErrors: any = {};
  marcaslist: any[] = [];
  modelolist: any[] = [];
  axios: AxiosVue = new AxiosVue(ServicioProxy.Integracion);
  readonly funcionalidad: Funcionalidades = Funcionalidades.MotivodeBaja;
  estadolist: any = [];
  fecha_sim: any = '';
  evt: any;

  userID = JSON.parse(localStorage.getItem('user')).id;

  guardar() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      {
        id: self.formFields.Id.value,
        Motivo: self.formFields.Motivo.value.toString().toUpperCase(),
        userID: self.userID,
        clienteDefecto: JSON.parse(localStorage.getItem('user')).clienteDefecto,
      },
      'MotivodeBaja/Creando'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          self.handleCerrar();
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  get fechaMaxima() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    let fechaMax = yyyy + '-' + mm + '-' + dd;
    return fechaMax;
  }

  formFields: FormFieldDefMap = {
    Id: {
      label: 'Id',
      id: '',
      value: '',
    },
    Motivo: {
      label: 'Motivo',
      id: '',
      value: '',
    },
    FechaActual: {
      label: 'Fecha De Registro',
      id: this.fechaMaxima,
      value: this.fechaMaxima,
    },

    Usuario: {
      label: 'Usuario',
      id: '',
      value: '',
    },
    estado: {
      label: 'Estado',
      id: '',
      value: 'ACTIVO',
    },
    fechamodi: {
      label: 'Fecha Modificacion',
      id: 'configid',
      value: '',
    },
  };
  initialize() {
    this.getnumero_usuario();
    this.dictionaryFormErrors = {
      custom: {
        ano: {
          required: () => config.errorMensajes.textoRequerido,
          numeric: config.errorMensajes.soloNumeros,
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);
  }

  mounted() {
    this.initialize();

    this.getnumero_usuario();
  }
  async getnumero_usuario() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      { id: JSON.parse(localStorage.getItem('user')).id },
      'MotivodeBaja/usuario_numero'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.formFields.Id.value = Number(data.data.numero.max) + 1;
          self.formFields.Usuario.value = data.data.usuario.concat_ws;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  @Watch('ReporteSeleccionado')
  handleRutasSeleccionadas() {
    return;
  }

  handleCerrar() {
    this.$emit('cerrar');
  }
}
